import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Calendar } from "primereact/calendar";
import RevisionTable from "../components/RevisionTable";
import { useGlobalContext } from "../../../Config";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import { Toast } from "primereact/toast";
import { useLocation } from "react-router-dom";
import { useRef } from "react";
import { ReportService } from "../../../services/ReportService.js";
import { getDetalleCotizacionByIdCotizacion } from "../../../services/CotizacionService.js";
import useCotizaciones from "../../../shared/hooks/useCotizaciones.js";

const Revision = (props) => {
  const [activeTab] = useState("Vigentes");
  const [filters2] = useState(null);
  const [displayBasic, setDisplayBasic] = useState(false);
  const [fila, setFila] = useState(null);
  const [producto, setProducto] = useState(null);
  const { baseUrl } = useGlobalContext();
  const estados = ["A", "E"];
  const usuarioId = sessionStorage.getItem("usuario_id");
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const reportService = new ReportService();

  // Manejar la notificación de éxito
  const location = useLocation();
  const toast = useRef(null);
  const navigate = useNavigate();    
  const hasShownToastRef = useRef(false);
    useEffect(() => {
    const incomingToast = location.state?.toast;
    if (incomingToast && !hasShownToastRef.current) {
      hasShownToastRef.current = true;
      toast.current?.show(incomingToast);
      // Limpia el estado para evitar que se dispare de nuevo
      navigate(location.pathname, {
        replace: true,
        state: { ...location.state, toast: undefined },
      });
    }
  }, [location.state, navigate, location.pathname]);


  const formatDate = (value) => {
    return value.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };
  const { cotizaciones, loading2, getCotizaciones } = useCotizaciones(
    baseUrl,
    usuarioId,
    ["3", "9"],
    setLoading
  );

  useEffect(() => {
    getCotizaciones();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
   // eslint-disable-line react-hooks/exhaustive-deps
  const dateFilterTemplate = (options) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        dateFormat="mm/dd/yy"
        placeholder="mm/dd/yyyy"
        mask="99/99/9999"
      />
    );
  };

  const desdeBodyTemplate = (rowData) => {
    return formatDate(rowData.desde);
  };

  const hastaBodyTemplate = (rowData) => {
    return formatDate(rowData.hasta);
  };

  const estadoBodyTemplate = (rowData) => {
    return (
      <span className={`customer-badge status-${rowData.estado}`}>
        {rowData.estado}
      </span>
    );
  };

  const estadoFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={estados}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        itemTemplate={statusItemTemplate}
        placeholder="Select a Status"
        className="p-column-filter"
        showClear
      />
    );
  };

  const statusItemTemplate = (option) => {
    return <span className={`customer-badge status-${option}`}>{option}</span>;
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <Button
          icon="pi pi-eye"
          label="Ver detalles"
          className="p-button-rounded p-button-info p-button mr-2 mb-2 mt-2"
          outlined
          onClick={() => handleRowClick(rowData)}
        />
      </div>
    );
  };

  const vencimientoBody = (rowData) => {
    if (!rowData.vencimiento) {
      return (
        <div>
          <Button
            label="No tiene fecha"
            className="p-button-rounded p-button-secondary p-button mr-2 mb-2 mt-2"
            outlined
            disabled
          />
        </div>
      );
    }

    try {
      let date;
      
      // Parsear fecha en formato dd/mm/yyyy
      if (typeof rowData.vencimiento === 'string' && rowData.vencimiento.includes('/')) {
        const [day, month, year] = rowData.vencimiento.split('/');
        // Evitar offset de zona horaria: construir en local
        date = new Date(Number(year), Number(month) - 1, Number(day));
      } else if (
        typeof rowData.vencimiento === 'string' &&
        rowData.vencimiento.includes('-') &&
        rowData.vencimiento.length === 10
      ) {
        // Formato yyyy-mm-dd -> construir en local para evitar UTC
        const [year, month, day] = rowData.vencimiento.split('-');
        date = new Date(Number(year), Number(month) - 1, Number(day));
      } else {
        date = new Date(rowData.vencimiento);
      }
      
      if (isNaN(date.getTime())) {
        return (
          <div>
            <Button
              label={rowData.estado}
              className="p-button-rounded p-button-warning p-button mr-2 mb-2 mt-2"
              outlined
              disabled
            />
          </div>
        );
      }
      
  
      // Calcular días hasta vencimiento
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      date.setHours(0, 0, 0, 0);
      const diffDays = Math.ceil((date - today) / (1000 * 60 * 60 * 24));
  
      let buttonClass = 'p-button-rounded p-button mr-2 mb-2 mt-2';
      let icon;
      let tooltip;

      if (diffDays < 0) {
        // Vencidas → Rojo
        buttonClass += ' p-button-danger';
        icon = 'pi pi-times-circle';
        tooltip = `Vencida hace ${Math.abs(diffDays)} día(s)`;
      } else if (diffDays === 0) {
        // Vence hoy → Naranja
        buttonClass += ' btn-orange';
        icon = 'pi pi-exclamation-circle';
        tooltip = 'Vence hoy';
      } else if (diffDays === 1) {
        // A 1 día → Naranja fuerte
        buttonClass += ' btn-orange';
        icon = 'pi pi-exclamation-triangle';
        tooltip = 'Vence en 1 día';
      } else if (diffDays <= 5) {
        // A 2-5 días → Amarillo
        icon = 'pi pi-clock';
        buttonClass += ' btn-yellow';
        tooltip = `Vence en ${diffDays} día(s)`;
      } else {
        // Más de 5 días → Verde
        buttonClass += ' p-button-success';
        icon = 'pi pi-check-circle';
        tooltip = `Vence en ${diffDays} día(s)`;
      }
  
      // Formatear fecha dd-mm-yy
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2);
      const formattedDate = `${day}/${month}/${year}`;
  
      return (
        <div>
          <Button
            icon={icon}
            label={formattedDate}
            className={buttonClass}
            outlined
            tooltip={tooltip}
            tooltipOptions={{ position: 'top' }}
          />
        </div>
      );
    } catch (error) {
      return (
        <div>
          <Button
            label="Error en fecha"
            className="p-button-rounded p-button-danger p-button mr-2 mb-2 mt-2"
            outlined
            disabled
          />
        </div>
      );
    }
  };

  const handleExportExcel = async () => {
    try {
      setExporting(true);
      await reportService.exportDetalleCotizaciones(baseUrl, ["3", "9"]);
      toast.current?.show({
        severity: "success",
        summary: "Exportación exitosa",
        detail: "Se descargó el archivo detalle_cotizaciones.xlsx",
        life: 3000,
      });
    } catch (error) {
      console.error(error);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "No se pudo exportar el archivo Excel",
        life: 3000,
      });
    } finally {
      setExporting(false);
    }
  };

  const handleRowClick = async (rowData) => {
    const idCotizacion = rowData.id;

    // Function to format date, ensuring the output is always in 'yyyy-mm-dd'
    const formatDate = (date, inputFormat) => {
      const parsedDate = moment(date, inputFormat);
      return parsedDate.isValid() ? parsedDate.format("YYYY-MM-DD") : "";
    };

    const formattedDesde = formatDate(rowData.desde, "DD/MM/YYYY");
    const formattedHasta = formatDate(rowData.hasta, "DD/MM/YYYY");

    if (rowData.estado.estado === "INGRESADA") {
      let newUrl = `/selectProductos?idCotizacion=${idCotizacion}&idCliente=${rowData.cliente.id}&selected=true&activeIndex=1`;
      navigate(newUrl);
    } else {
      try {
        setLoading(true);
        const data = await getDetalleCotizacionByIdCotizacion(baseUrl, idCotizacion);

        if (data.mensaje === "OK") {
          let newUrl = `/revisarCotizacion?idCliente=${rowData.cliente.id}&idCotizacion=${idCotizacion}&desde=${formattedDesde}&hasta=${formattedHasta}`;
          navigate(newUrl);
        } else {
          alert(data.mensaje);
        }
      } catch (error) {
        alert("Hubo un error al crear la cotización");
      } finally {
        setLoading(false);
      }
    }
  };


  return (
    <>
      <div className="grid table-demo">
        <div className="col-12">
          <div className="card">
            <h4 style={{ marginBottom: "5px" }}>Cotizaciones</h4>
            <h6 style={{ marginTop: "5px" }}>¿Qué cotizaciones hemos enviado?</h6>
          </div> 
        </div>
        <div className="col-12">
        <Card>
          <Button
            label="Nueva Cotización"
            icon="pi pi-plus"
            className="mr-2 mb-2 p-button-rounded p-button"
            onClick={() =>
              navigate("/cotizacion", {
                state: { toggleFormVisibility: true },
              })
            }
            raised
          />
          <Button
            label="Exportar Excel"
            icon="pi pi-file-excel"
            className="p-button-rounded p-button-success mb-2"
            onClick={handleExportExcel}
            loading={exporting}
            disabled={exporting}
          />
          <RevisionTable
            activeTab={activeTab}
            revision={cotizaciones || []}
            filters={filters2}
            loading={loading || loading2}
            desdeBodyTemplate={desdeBodyTemplate}
            dateFilterTemplate={dateFilterTemplate}
            hastaBodyTemplate={hastaBodyTemplate}
            estadoBodyTemplate={estadoBodyTemplate}
            estadoFilterTemplate={estadoFilterTemplate}
            vencimientoBody={vencimientoBody}
            actionBodyTemplate={actionBodyTemplate}
            setDisplayBasic={setDisplayBasic}
            displayBasic={displayBasic}
            fila={fila}
            setFila={setFila}
            producto={producto}
            setProducto={setProducto}
            handleRowClick={handleRowClick}
          />
        </Card>
        </div>
      </div>
      {/* Contenedor global de Toast para esta página */}
      <Toast ref={toast} />
    </>
    
  );
};

export default Revision;
